
export default {
  firstTimeLoad: false,
  contactDetailsForTab: {},
  contactHistoryForTab: [],
  mainListSavedFilter: {},
  mainListQuickFilters: [],
  quickFiltersDatesFrom: [],
  quickFiltersDatesTo: [],
  sortField: '',
  sortFieldId: 0,
  sortOrder: 0,
  page: 1,
  rows: 25,
  searchText: '',
  scrollY: 0,
  gridScrollY: 0,
  hardLoad: 0,
  softReload: 0
}